<!-- "Skip to main content" comes from the app shell (app.html). -->
<a class="skip-link" href="#footer">{{ 'landing.skipToFooter' | t }}</a>

<!-- ── Nav ──────────────────────────────────────────── -->
<app-site-header></app-site-header>

<main id="main-content" tabindex="-1" role="main">
  <app-hero-widget [isUserLogged]="isAuthenticated()" (primary)="onGetStarted()"></app-hero-widget>

  <app-quote-widget></app-quote-widget>

  <app-feature-stage-widget></app-feature-stage-widget>

  <app-encrypted-widget></app-encrypted-widget>

  <app-upload-section-widget
    [isAuthenticated]="isAuthenticated()"
    [disabled]="analysisActive()"
    (fileSelectedOut)="onSelectFile($event)"
    (loginRequiredOut)="onLoginRequired()"
  ></app-upload-section-widget>

  <app-features-widget></app-features-widget>

  <app-faqs-widget (contact)="onContactUs()"></app-faqs-widget>

  <app-contact-widget (contact)="onContactUs()" (bookDemo)="onBookDemo()"></app-contact-widget>
</main>

<!-- ── Footer ──────────────────────────────────────── -->
<app-site-footer></app-site-footer>

<!-- Contact modal opened by the contact band's CTA -->
<app-contact-modal
  [open]="contactModalOpen()"
  (dismissed)="contactModalOpen.set(false)"
></app-contact-modal>

<!-- Upload-confirm dialog -->
<app-upload-confirm-dialog
  [open]="!!pendingFile()"
  [fileName]="pendingFileName()"
  (confirmed)="confirmUpload()"
  (cancelled)="cancelUpload()"
></app-upload-confirm-dialog>

<!-- Login-required gate for anonymous upload attempts -->
<app-login-gate-dialog
  [open]="loginGateOpen()"
  (login)="goToLogin()"
  (dismissed)="dismissLoginGate()"
></app-login-gate-dialog>

<!-- Billing-fallback dialog: the active plan's pool is exhausted but another
     subscription or the personal wallet could pay. The user decides first. -->
<app-billing-fallback-dialog
  [open]="!!billingFallbackDecision()"
  [copy]="billingFallbackCopy()"
  [variant]="billingFallbackDecision()?.kind === 'switch' ? 'switch' : 'wallet'"
  (confirmed)="confirmBillingFallback()"
  (dismissed)="dismissBillingFallback()"
></app-billing-fallback-dialog>

<!-- Credits gate for authenticated visitors whose wallet can't cover an analysis -->
<app-upgrade-gate-dialog
  [open]="creditsExhausted()"
  [reason]="tokenGateReason()"
  [title]="gateTitle()"
  [message]="gateMessage()"
  [resetDate]="tokenGateResetDate()"
  (upgrade)="goToUpgrade()"
  (dismissed)="dismissGate()"
></app-upgrade-gate-dialog>
